import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../Api/AdminApi";
import {Tile} from 'Components/Tile/Tile'
import {IoMdSchool} from 'react-icons/io'
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import {SelectInput, TextInput} from "../Components/Input/Input";
import {push} from "../Utils/validation";

const ELEMENT_TYPES = {
    'BUTTON': 'Button',
    'PAGE': 'Page',
}

const GrowthDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [request, setRequest] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [showCampaignCreationModal, setShowCampaignCreationModal] = useState(false)
    const [showElementCreationModal, setShowElementCreationModal] = useState(false)
    const [showElementInteractionDetails, setShowElementInteractionDetails] = useState(false)
    const [growthPageData, setGrowthPageData] = useState(null);
    const [selectedCampaign, setSelectedCampaign] = useState(undefined)
    const [campaigns, setCampaigns] = useState({})
    const [elements, setElements] = useState(undefined)
    const [interactionDetails, setInteractionDetails] = useState(undefined)
    const [resetFilter, setResetFilter] = useState(false)
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')

    useEffect(() => {
        if (resetFilter) {
            setTopic('')
        }
    }, [resetFilter])

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.replaceAll(' ', '-'))
        setFilterOpen(false)
    }

    useEffect(() => {
        AdminApi.Metrics.getAdminPageGrowthData({}, session.jwt).then(res => {
            setGrowthPageData(res.data);
            setElements(res.data?.unmappedElements)

            const newCampaigns = {}
            res.data?.campaigns.forEach(campaign => newCampaigns[campaign.id] = campaign.title)
            setCampaigns(newCampaigns);

        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }, [session.jwt])


    function handleChange(event) {
        const { name, value } = event.target;
        setRequest((prevState) => ({ ...prevState, [name]: value }));
    }

    const createCampaign = () => {
        setLoading(true)
        setFormErrors({});
        setError(undefined)

        const errors = validateCampaignRequest(request);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setLoading(false)
            return;
        }

        AdminApi.Metrics.createNewGrowthCampaign(request, session.jwt).then((res) => {
            setLoading(false)
            setFormErrors({});
            setError(undefined)
            setShowCampaignCreationModal(false)
            setRequest({})
        }).catch((ignored) => {
            setLoading(false)
            setError('Unable to create the campaign')
        });
    }

    const createElement = () => {
        setLoading(true)
        setFormErrors({});
        setError(undefined)

        const errors = validateElementRequest(request);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setLoading(false)
            return;
        }

        AdminApi.Metrics.createNewGrowthElement(request, session.jwt).then((res) => {
            setLoading(false)
            setFormErrors({});
            setError(undefined)
            setShowCampaignCreationModal(false)
            setRequest({})
        }).catch((ignored) => {
            setLoading(false)
            setError('Unable to create the campaign')
        });
    }

    function validateCampaignRequest(req) {
        const errors = {};
        if (!req.title) {
            push(errors, 'title', 'A title is required');
        }
        if (!req.description) {
            push(errors, 'description', 'A description is required');
        }
        return errors;
    }

    function validateElementRequest(req) {
        const errors = {};
        if (!req.campaignId) {
            push(errors, 'campaignId', 'A Campaign is required');
        }
        if (!req.title) {
            push(errors, 'title', 'A title is required');
        }
        if (!req.description) {
            push(errors, 'description', 'A description is required');
        }
        if (!req.elementType) {
            push(errors, 'elementType', 'An element type is required');
        }
        return errors;
    }

    const filterElementsForCampaign = (campaignId) => {
        const filteredElements = growthPageData.unmappedElements.filter(element =>
            element.elementInteractions?.some(interaction =>
                interaction.campaignId === campaignId || interaction.growthCampaignId === campaignId));

        setElements(filteredElements);
    }

    const hideElementInteractionDetails = () => {
        setInteractionDetails(undefined)
        setShowElementInteractionDetails(false)
    }

    return <div>
        <SideBar session={session} title={"Growth"}>
            <div className={s.adminDashboard}>
                <Modal fullscreen={'md-down'} show={showCampaignCreationModal} onHide={()=> {
                    setRequest({})
                    setFormErrors({})
                    setError(undefined)
                    setShowCampaignCreationModal(false);
                }}>
                    <Modal.Header closeButton/>
                    <Modal.Title>
                        <h3 style={{textAlign: 'center'}}>Create New Campaign</h3>
                    </Modal.Title>
                    <Modal.Body>
                        <Form>
                            <TextInput containerClassName='mb-1' type="text" errors={formErrors} name="title" value={request.title || ''}
                                       onChange={handleChange} label="Title"/>
                            <TextInput containerClassName='mb-1' type="text" errors={formErrors} name="description" value={request.description || ''}
                                       onChange={handleChange} label="Description"/>
                        </Form>
                        <Button onClick={createCampaign} disabled={loading}
                                className="btnFill wide d-block mt-3 p-2 fs-16 fw-bold">{loading ? "Creating..." : "Create Campaign"}</Button>
                        <p className={s.errorText}>{error ?? ''}</p>
                    </Modal.Body>
                </Modal>

                <Modal fullscreen={'md-down'} show={showElementCreationModal} onHide={()=> {
                    setRequest({})
                    setFormErrors({})
                    setError(undefined)
                    setShowElementCreationModal(false);
                }}>
                    <Modal.Header closeButton/>
                    <Modal.Title>
                        <h3 style={{textAlign: 'center'}}>Create New Element</h3>
                    </Modal.Title>
                    <Modal.Body>
                        <Form>
                            <SelectInput containerClassName='mb-3' id={'campaignId'}
                                         label="Campaign"
                                         placeholder={'Select Campaign'}
                                         options={campaigns} errors={formErrors} name="campaignId"
                                         value={request.campaignId} onChange={handleChange}/>
                            <TextInput containerClassName='mb-1' type="text" errors={formErrors} name="title" value={request.title || ''}
                                       onChange={handleChange} label="Title"/>
                            <TextInput containerClassName='mb-1' type="text" errors={formErrors} name="description" value={request.description || ''}
                                       onChange={handleChange} label="Description"/>
                            <SelectInput containerClassName='mb-3' id={'elementType'}
                                         label="Element Type"
                                         placeholder={'Select Type'}
                                         options={ELEMENT_TYPES} errors={formErrors} name="elementType"
                                         value={request.elementType} onChange={handleChange}/>
                        </Form>
                        <Button onClick={createElement} disabled={loading}
                                className="btnFill wide d-block mt-3 p-2 fs-16 fw-bold">{loading ? "Creating..." : "Create Element"}</Button>
                        <p className={s.errorText}>{error ?? ''}</p>
                    </Modal.Body>
                </Modal>

                <main className={s.dataSection}>
                    <h3 className='heading'>{growthPageData ? (growthPageData.campaigns ?? []).length : 'All'} Campaigns</h3>
                    <div className={s.viewModalButtonContainer}>
                        <div onClick={() => {
                            setShowCampaignCreationModal(true)
                        }} className={`${s.createCampaignCard}`}>
                            <div className={s.createCampaignCardBody}>
                                Create Campaign
                            </div>
                        </div>
                    </div>
                    <div className={s.campaignListContainer}>
                        <div className={s.campaignList}>
                            {growthPageData ? growthPageData.campaigns?.map((campaign, idx) =>
                                    <GrowthCampaignCard selectedCampaign={selectedCampaign}
                                                        setSelectedCampaign={setSelectedCampaign}
                                                        campaign={campaign}
                                                        resetFilter={() => setElements(growthPageData.unmappedElements)}
                                                        filterElementsForCampaign={(campaignId) => filterElementsForCampaign(campaignId)}/>
                                ) :
                                <>
                                    <GrowthCampaignCard/>
                                    <GrowthCampaignCard/>
                                    <GrowthCampaignCard/>
                                    <GrowthCampaignCard/>
                                </>}
                        </div>
                    </div>
                    <h3 className='heading mt-4'>{elements ? elements?.length : 'All'} Elements</h3>
                    <div className={s.viewModalButtonContainer}>
                        <div onClick={() => {
                            setShowElementCreationModal(true)
                        }} className={`${s.createCampaignCard}`}>
                            <div className={s.createCampaignCardBody}>
                                Create Element
                            </div>
                        </div>

                        {selectedCampaign &&
                            <div onClick={() => {
                                setShowElementInteractionDetails(true)
                            }} className={`${s.createCampaignCard}`}>
                                <div className={s.createCampaignCardBody}>
                                    Show Path
                                </div>
                            </div>
                        }
                    </div>
                    <ElementInteractionDetailsModal interactionDetails={interactionDetails ? interactionDetails.filter(details => {
                        if (selectedCampaign) {
                            return details.campaignId === selectedCampaign || details.growthCampaignId === selectedCampaign
                        } else {
                            return true;
                        }
                    }) : elements?.flatMap((element) => element.elementInteractions.filter(details =>
                        details.campaignId === selectedCampaign || details.growthCampaignId === selectedCampaign)
                    )}
                                                    showElementInteractionDetails={showElementInteractionDetails}
                                                    hideElementInteractionDetails={hideElementInteractionDetails}/>

                    <div className={s.elementListContainer}>
                        <div className={s.elementList}>
                            {elements ? elements.map((element) =>
                                    <ElementCard elementDetails={element} viewElementDetails={() => {
                                        setInteractionDetails(element.elementInteractions)
                                        if (element.elementInteractions) {
                                            setShowElementInteractionDetails(true)
                                        }
                                    }}/>
                                ) :
                                <>
                                    <ElementCard/>
                                    <ElementCard/>
                                    <ElementCard/>
                                    <ElementCard/>
                                    <ElementCard/>
                                </>
                            }
                        </div>
                    </div>
                </main>
                <aside className={s.filterSection}>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Campaigns</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All Campaigns</Button>
                                        {[].map((blogTopic, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All Campaigns</Button>
                                {[].map((blogTopic, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>

                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Elements</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All Elements</Button>
                                        {[].map((blogTopic, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All Elements</Button>
                                {[].map((blogTopic, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>
                </aside>
            </div>
        </SideBar>
    </div>
}

const GrowthCampaignCard = ({ campaign, filterElementsForCampaign, resetFilter, selectedCampaign, setSelectedCampaign }) => {
    function toggleSelection() {
        if (setSelectedCampaign) {
            if (selectedCampaign === campaign.id) {
                resetFilter()
                setSelectedCampaign(undefined)
            } else {
                setSelectedCampaign(campaign.id)
                filterElementsForCampaign(campaign.id)
            }
        }
    }

    return <div onClick={toggleSelection} className={`${s.impressionCard} ${selectedCampaign && selectedCampaign === campaign.id ? s.selectedCard : ''}`}>
        {campaign ?
            <>
                <p style={{fontSize: '15px'}} className={`mt-2 mb-1`}>
                    <strong>Campaign ID:</strong> {campaign.id}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerPurple}`}></div>
            </>
        }
        {campaign ?
            <>
                <p style={{fontSize: '15px'}} className={`mt-1 mb-1`}>
                    <strong>Title:</strong> {campaign.title}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerPurple}`}></div>
            </>
        }

        {campaign ?
            <>
                {campaign.description &&
                    <p style={{fontSize: '15px'}} className={s.impressionCardDescription}>
                        <strong>Description:</strong> {campaign.description}
                    </p>
                }
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg} mt-4 mb-2`}></div>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
            </>
        }

        {campaign ?
            <>
                <Tile width={'100%'} fontSize={'0.8em'} color={'green'}>{new Date(campaign.creationTimestamp).toDateString()}</Tile>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerGreen} mb-2`}></div>
            </>
        }
    </div>
};

const ElementCard = ({elementDetails, viewElementDetails }) => {
    return <div onClick={viewElementDetails} className={`${s.elementCard}`}>
        {elementDetails ?
            <>
                <Card.Text className={'mt-2 mb-3 fw-bold'} style={{fontSize: '15px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    {elementDetails.title?.lenth > 0 ? elementDetails.title : elementDetails.id}
                </Card.Text>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}></div>
            </>
        }

        {elementDetails ?
            <>
                {elementDetails.description &&
                    <Card.Text style={{fontSize: '13px'}} className='trunc mb-2'>
                        <IoMdSchool color='#7678ed'/> {' '}{elementDetails.description}
                    </Card.Text>
                }
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
            </>
        }

        {elementDetails ?
            <>
                {elementDetails.campaignTitle &&
                    <Card.Text style={{fontSize: '13px'}} className='trunc mb-2'>
                        <IoMdSchool color='#7678ed'/> {' '}{elementDetails.campaignTitle}
                    </Card.Text>
                }
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
            </>
        }

        {elementDetails ?
            <>
                <Tile width={'100%'} fontSize={'0.8em'} color={'green'}>{elementDetails.type}</Tile>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerGreen} mb-2`}></div>
            </>
        }
    </div>
};

const ElementInteractionDetailsModal = ({ interactionDetails, showElementInteractionDetails, hideElementInteractionDetails }) => {

    return <Modal fullscreen={'md-down'} show={showElementInteractionDetails} onHide={()=> {hideElementInteractionDetails()}}>
        <Modal.Header closeButton/>
        <Modal.Title>
            <h3 style={{textAlign: 'center'}}>Interaction Log</h3>
        </Modal.Title>
        <Modal.Body>
            <p className={'mb-2'}><strong>{interactionDetails?.length} interactions</strong></p>
            <div className={s.interactionLogList}>
                {interactionDetails?.toSorted((a, b) => b.timestamp - a.timestamp).map((interaction) => (
                    <>
                        <div className={s.interactionLogEntry}>
                            {interaction ?
                                <>
                                    <p style={{fontSize: '15px'}} className={'mt-3 mb-2'}>
                                        <strong>Element ID:</strong> {interaction.elementId}
                                    </p>
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                </>
                            }
                            {interaction ?
                                <>
                                    <p style={{fontSize: '15px'}} className={'mt-3 mb-2'}>
                                        <strong>Interaction ID:</strong> {interaction.id}
                                    </p>
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.deviceId &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>Device ID:</strong> {interaction.deviceId}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.userExternalId &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>User Internal ID:</strong> {interaction.userExternalId}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.userInternalId &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>User External ID:</strong>{interaction.userInternalId}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.campaignId &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>Legacy Campaign ID:</strong>{interaction.campaignId}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.growthCampaignId &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>Growth Campaign ID:</strong>{interaction.growthCampaignId}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.source &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>Legacy Source:</strong> {interaction.source}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.interactionSource &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>Source:</strong> {interaction.interactionSource}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.ipAddress &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>IP Address:</strong> {interaction.ipAddress}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    {interaction.timestamp &&
                                        <p style={{fontSize: '15px'}} className='trunc mb-2'>
                                            <strong>Date:</strong> {new Date(interaction.timestamp).toLocaleDateString()} at {new Date(interaction.timestamp).toLocaleTimeString()}
                                        </p>
                                    }
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}></div>
                                </>
                            }

                            {interaction ?
                                <>
                                    <Tile width={'100%'} fontSize={'0.8em'} color={'green'}>{interaction.type || interaction.interactionType}</Tile>
                                </> :
                                <>
                                    <div className={`${s.textPlaceHolder} ${s.shimmerBg} mb-2`}
                                         style={{background: '#23CDAA'}}></div>
                                </>
                            }
                        </div>
                    </>
                ))}
            </div>
        </Modal.Body>
    </Modal>
};

export default (GrowthDashboard);
